import { render, staticRenderFns } from "./modificationOfWeigh.vue?vue&type=template&id=bbd61ad8&scoped=true&"
import script from "./modificationOfWeigh.vue?vue&type=script&lang=js&"
export * from "./modificationOfWeigh.vue?vue&type=script&lang=js&"
import style0 from "./modificationOfWeigh.vue?vue&type=style&index=0&id=bbd61ad8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd61ad8",
  null
  
)

export default component.exports